// https://github.com/kundigo/react-native-telephone-input
// So each country array has the following information:
// [
//    Country name,
//    iso2 code,
//    International dial code,
//    Order (if >1 country with same dial code),
//    Area codes (if >1 country with same dial code)
// ]

import {i18n} from '@yourcoach/i18n';

const countriesRaw: Array<[string, string, string, number?, string[]?]> = [
  ['Australia', 'au', '61'],
  ['Austria', 'at', '43'],
  ['Azerbaijan', 'az', '994'],
  ['Bahamas', 'bs', '1242'],
  ['Bahrain', 'bh', '973'],
  ['Bangladesh', 'bd', '880'],
  ['Barbados', 'bb', '1246'],
  ['Belarus', 'by', '375'],
  ['Belgium', 'be', '32'],
  ['Belize', 'bz', '501'],
  ['Benin', 'bj', '229'],
  ['Bermuda', 'bm', '1441'],
  ['Bhutan', 'bt', '975'],
  ['Bolivia', 'bo', '591'],
  ['Bosnia and Herzegovina', 'ba', '387'],
  ['Botswana', 'bw', '267'],
  ['Brazil', 'br', '55'],
  ['British Indian Ocean Territory', 'io', '246'],
  ['British Virgin Islands', 'vg', '1284'],
  ['Brunei', 'bn', '673'],
  ['Bulgaria', 'bg', '359'],
  ['Burkina Faso', 'bf', '226'],
  ['Burundi', 'bi', '257'],
  ['Cambodia', 'kh', '855'],
  ['Cameroon', 'cm', '237'],
  [
    'Canada',
    'ca',
    '1',
    1,
    [
      '204',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
  ],
  ['Cape Verde', 'cv', '238'],
  ['Caribbean Netherlands', 'bq', '599', 1],
  ['Cayman Islands', 'ky', '1345'],
  ['Central African Republic', 'cf', '236'],
  ['Chad', 'td', '235'],
  ['Chile', 'cl', '56'],
  ['China', 'cn', '86'],
  ['Colombia', 'co', '57'],
  ['Comoros', 'km', '269'],
  ['Congo (DRC)', 'cd', '243'],
  ['Congo (Republic)', 'cg', '242'],
  ['Cook Islands', 'ck', '682'],
  ['Costa Rica', 'cr', '506'],
  ['Côte d’Ivoire', 'ci', '225'],
  ['Croatia', 'hr', '385'],
  ['Cuba', 'cu', '53'],
  ['Curaçao', 'cw', '599', 0],
  ['Cyprus', 'cy', '357'],
  ['Czech Republic', 'cz', '420'],
  ['Denmark', 'dk', '45'],
  ['Djibouti', 'dj', '253'],
  ['Dominica', 'dm', '1767'],
  ['Dominican Republic', 'do', '1', 2, ['809', '829', '849']],
  ['Ecuador', 'ec', '593'],
  ['Egypt', 'eg', '20'],
  ['El Salvador', 'sv', '503'],
  ['Equatorial Guinea', 'gq', '240'],
  ['Eritrea', 'er', '291'],
  ['Estonia', 'ee', '372'],
  ['Ethiopia', 'et', '251'],
  ['Falkland Islands', 'fk', '500'],
  ['Faroe Islands', 'fo', '298'],
  ['Fiji', 'fj', '679'],
  ['Finland', 'fi', '358'],
  ['France', 'fr', '33'],
  ['French Guiana', 'gf', '594'],
  ['French Polynesia', 'pf', '689'],
  ['Gabon', 'ga', '241'],
  ['Gambia', 'gm', '220'],
  ['Georgia', 'ge', '995'],
  ['Germany', 'de', '49'],
  ['Ghana', 'gh', '233'],
  ['Gibraltar', 'gi', '350'],
  ['Greece', 'gr', '30'],
  ['Greenland', 'gl', '299'],
  ['Grenada', 'gd', '1473'],
  ['Guadeloupe', 'gp', '590', 0],
  ['Guam', 'gu', '1671'],
  ['Guatemala', 'gt', '502'],
  ['Guinea', 'gn', '224'],
  ['Guinea-Bissau', 'gw', '245'],
  ['Guyana', 'gy', '592'],
  ['Haiti', 'ht', '509'],
  ['Honduras', 'hn', '504'],
  ['Hong Kong', 'hk', '852'],
  ['Hungary', 'hu', '36'],
  ['Iceland', 'is', '354'],
  ['India', 'in', '91'],
  ['Indonesia', 'id', '62'],
  ['Iran', 'ir', '98'],
  ['Iraq', 'iq', '964'],
  ['Ireland', 'ie', '353'],
  ['Israel', 'il', '972'],
  ['Italy', 'it', '39', 0],
  ['Jamaica', 'jm', '1876'],
  ['Japan', 'jp', '81'],
  ['Jordan', 'jo', '962'],
  ['Kazakhstan', 'kz', '7', 1],
  ['Kenya', 'ke', '254'],
  ['Kiribati', 'ki', '686'],
  ['Kuwait', 'kw', '965'],
  ['Kyrgyzstan', 'kg', '996'],
  ['Laos', 'la', '856'],
  ['Latvia', 'lv', '371'],
  ['Lebanon', 'lb', '961'],
  ['Lesotho', 'ls', '266'],
  ['Liberia', 'lr', '231'],
  ['Libya', 'ly', '218'],
  ['Liechtenstein', 'li', '423'],
  ['Lithuania', 'lt', '370'],
  ['Luxembourg', 'lu', '352'],
  ['Macau', 'mo', '853'],
  ['Macedonia', 'mk', '389'],
  ['Madagascar', 'mg', '261'],
  ['Malawi', 'mw', '265'],
  ['Malaysia', 'my', '60'],
  ['Maldives', 'mv', '960'],
  ['Mali', 'ml', '223'],
  ['Malta', 'mt', '356'],
  ['Marshall Islands', 'mh', '692'],
  ['Martinique', 'mq', '596'],
  ['Mauritania', 'mr', '222'],
  ['Mauritius', 'mu', '230'],
  ['Mexico', 'mx', '52'],
  ['Micronesia', 'fm', '691'],
  ['Moldova', 'md', '373'],
  ['Monaco', 'mc', '377'],
  ['Mongolia', 'mn', '976'],
  ['Montenegro', 'me', '382'],
  ['Montserrat', 'ms', '1664'],
  ['Morocco', 'ma', '212'],
  ['Mozambique', 'mz', '258'],
  ['Myanmar', 'mm', '95'],
  ['Namibia', 'na', '264'],
  ['Nauru', 'nr', '674'],
  ['Nepal', 'np', '977'],
  ['Netherlands', 'nl', '31'],
  ['New Caledonia', 'nc', '687'],
  ['New Zealand', 'nz', '64'],
  ['Nicaragua', 'ni', '505'],
  ['Niger', 'ne', '227'],
  ['Nigeria', 'ng', '234'],
  ['Niue', 'nu', '683'],
  ['Norfolk Island', 'nf', '672'],
  ['North Korea', 'kp', '850'],
  ['Northern Mariana Islands', 'mp', '1670'],
  ['Norway', 'no', '47'],
  ['Oman', 'om', '968'],
  ['Pakistan ', 'pk', '92'],
  ['Palau', 'pw', '680'],
  ['Palestine', 'ps', '970'],
  ['Panama', 'pa', '507'],
  ['Papua New Guinea', 'pg', '675'],
  ['Paraguay', 'py', '595'],
  ['Peru', 'pe', '51'],
  ['Philippines', 'ph', '63'],
  ['Poland', 'pl', '48'],
  ['Portugal', 'pt', '351'],
  ['Puerto Rico', 'pr', '1', 3, ['787', '939']],
  ['Qatar', 'qa', '974'],
  ['Réunion', 're', '262'],
  ['Romania', 'ro', '40'],
  ['Russia', 'ru', '7', 0],
  ['Rwanda', 'rw', '250'],
  ['Saint Barthélemy', 'bl', '590', 1],
  ['Saint Helena', 'sh', '290'],
  ['Saint Kitts and Nevis', 'kn', '1869'],
  ['Saint Lucia', 'lc', '1758'],
  ['Saint Martin', 'mf', '590', 2],
  ['Saint Pierre and Miquelon', 'pm', '508'],
  ['Saint Vincent and the Grenadines', 'vc', '1784'],
  ['Samoa', 'ws', '685'],
  ['San Marino', 'sm', '378'],
  ['São Tomé and Príncipe', 'st', '239'],
  ['Saudi Arabia', 'sa', '966'],
  ['Senegal', 'sn', '221'],
  ['Serbia', 'rs', '381'],
  ['Seychelles', 'sc', '248'],
  ['Sierra Leone', 'sl', '232'],
  ['Singapore', 'sg', '65'],
  ['Sint Maarten', 'sx', '1721'],
  ['Slovakia', 'sk', '421'],
  ['Slovenia', 'si', '386'],
  ['Solomon Islands', 'sb', '677'],
  ['Somalia', 'so', '252'],
  ['South Africa', 'za', '27'],
  ['South Korea', 'kr', '82'],
  ['South Sudan', 'ss', '211'],
  ['Spain', 'es', '34'],
  ['Sri Lanka', 'lk', '94'],
  ['Sudan', 'sd', '249'],
  ['Suriname', 'sr', '597'],
  ['Swaziland', 'sz', '268'],
  ['Sweden', 'se', '46'],
  ['Switzerland', 'ch', '41'],
  ['Syria', 'sy', '963'],
  ['Taiwan', 'tw', '886'],
  ['Tajikistan', 'tj', '992'],
  ['Tanzania', 'tz', '255'],
  ['Thailand', 'th', '66'],
  ['Timor-Leste', 'tl', '670'],
  ['Togo', 'tg', '228'],
  ['Tokelau', 'tk', '690'],
  ['Tonga', 'to', '676'],
  ['Trinidad and Tobago', 'tt', '1868'],
  ['Tunisia', 'tn', '216'],
  ['Turkey', 'tr', '90'],
  ['Turkmenistan', 'tm', '993'],
  ['Turks and Caicos Islands', 'tc', '1649'],
  ['Tuvalu', 'tv', '688'],
  ['U.S. Virgin Islands', 'vi', '1340'],
  ['Uganda', 'ug', '256'],
  ['Ukraine', 'ua', '380'],
  ['United Arab Emirates', 'ae', '971'],
  ['United Kingdom', 'gb', '44'],
  ['United States', 'us', '1', 0],
  ['Uruguay', 'uy', '598'],
  ['Uzbekistan', 'uz', '998'],
  ['Vanuatu', 'vu', '678'],
  ['Vatican City', 'va', '39', 1],
  ['Venezuela', 've', '58'],
  ['Vietnam', 'vn', '84'],
  ['Wallis and Futuna', 'wf', '681'],
  ['Yemen', 'ye', '967'],
  ['Zambia', 'zm', '260'],
  ['Zimbabwe', 'zw', '263'],
];

// we will build this in the loop below
export interface Country {
  dialCode: string;
  hasAreaCodes: boolean;
  iso2: string;
  name: string;
  priority: number;
  toString: () => string;
}

export const getCountries = () => {
  const countries: Country[] = [];

  const countryIso2Lookup: {[key: string]: Country} = {};

  const countryDialCodeLookup: {[key: string]: string[]} = {};

  const countriesCount = countriesRaw.length;

  const addCountryDialCode = (
    iso2: string,
    dialCode: string,
    priority: number,
  ) => {
    if (!(dialCode in countryDialCodeLookup)) {
      countryDialCodeLookup[dialCode] = [];
    }

    const index = priority || 0;

    countryDialCodeLookup[dialCode]![index] = iso2;
  };

  for (let i = 0; i < countriesCount; i += 1) {
    const rawCountry = countriesRaw[i]!;

    const countryName = getCountryName(rawCountry[1]);

    countries[i] = {
      dialCode: rawCountry[2],
      hasAreaCodes: false,
      iso2: rawCountry[1],
      name: countryName,
      priority: rawCountry[3] || 0,
      toString: () => countryName,
    };

    const country = countries[i]!;

    // area codes
    if (rawCountry[4] && rawCountry[4].length) {
      country.hasAreaCodes = true;

      for (let j = 0; j < rawCountry[4].length; j += 1) {
        // full dial code is country code + dial code
        const dialCode = rawCountry[2] + rawCountry[4][j];

        addCountryDialCode(country.iso2, dialCode, country.priority);
      }
    }

    countryIso2Lookup[rawCountry[1]] = country;

    // dial codes
    addCountryDialCode(country.iso2, country.dialCode, country.priority);
  }

  return {countries, countryDialCodeLookup, countryIso2Lookup};
};

const getCountryName = (iso2: string) => {
  /**
   * @i18n_parser
   * t('geo:country.ae')
   * t('geo:country.at')
   * t('geo:country.au')
   * t('geo:country.az')
   * t('geo:country.ba')
   * t('geo:country.bb')
   * t('geo:country.bd')
   * t('geo:country.be')
   * t('geo:country.bf')
   * t('geo:country.bg')
   * t('geo:country.bh')
   * t('geo:country.bi')
   * t('geo:country.bj')
   * t('geo:country.bl')
   * t('geo:country.bm')
   * t('geo:country.bn')
   * t('geo:country.bo')
   * t('geo:country.bq')
   * t('geo:country.br')
   * t('geo:country.bs')
   * t('geo:country.bt')
   * t('geo:country.bw')
   * t('geo:country.by')
   * t('geo:country.bz')
   * t('geo:country.ca')
   * t('geo:country.cd')
   * t('geo:country.cf')
   * t('geo:country.cg')
   * t('geo:country.ch')
   * t('geo:country.ci')
   * t('geo:country.ck')
   * t('geo:country.cl')
   * t('geo:country.cm')
   * t('geo:country.cn')
   * t('geo:country.co')
   * t('geo:country.cr')
   * t('geo:country.cu')
   * t('geo:country.cv')
   * t('geo:country.cw')
   * t('geo:country.cy')
   * t('geo:country.cz')
   * t('geo:country.de')
   * t('geo:country.dj')
   * t('geo:country.dk')
   * t('geo:country.dm')
   * t('geo:country.do')
   * t('geo:country.ec')
   * t('geo:country.ee')
   * t('geo:country.eg')
   * t('geo:country.er')
   * t('geo:country.es')
   * t('geo:country.et')
   * t('geo:country.fi')
   * t('geo:country.fj')
   * t('geo:country.fk')
   * t('geo:country.fm')
   * t('geo:country.fo')
   * t('geo:country.fr')
   * t('geo:country.ga')
   * t('geo:country.gb')
   * t('geo:country.gd')
   * t('geo:country.ge')
   * t('geo:country.gf')
   * t('geo:country.gh')
   * t('geo:country.gi')
   * t('geo:country.gl')
   * t('geo:country.gm')
   * t('geo:country.gn')
   * t('geo:country.gp')
   * t('geo:country.gq')
   * t('geo:country.gr')
   * t('geo:country.gt')
   * t('geo:country.gu')
   * t('geo:country.gw')
   * t('geo:country.gy')
   * t('geo:country.hk')
   * t('geo:country.hn')
   * t('geo:country.hr')
   * t('geo:country.ht')
   * t('geo:country.hu')
   * t('geo:country.id')
   * t('geo:country.ie')
   * t('geo:country.il')
   * t('geo:country.in')
   * t('geo:country.io')
   * t('geo:country.iq')
   * t('geo:country.ir')
   * t('geo:country.is')
   * t('geo:country.it')
   * t('geo:country.jm')
   * t('geo:country.jo')
   * t('geo:country.jp')
   * t('geo:country.ke')
   * t('geo:country.kg')
   * t('geo:country.kh')
   * t('geo:country.ki')
   * t('geo:country.km')
   * t('geo:country.kn')
   * t('geo:country.kp')
   * t('geo:country.kr')
   * t('geo:country.kw')
   * t('geo:country.ky')
   * t('geo:country.kz')
   * t('geo:country.la')
   * t('geo:country.lb')
   * t('geo:country.lc')
   * t('geo:country.li')
   * t('geo:country.lk')
   * t('geo:country.lr')
   * t('geo:country.ls')
   * t('geo:country.lt')
   * t('geo:country.lu')
   * t('geo:country.lv')
   * t('geo:country.ly')
   * t('geo:country.ma')
   * t('geo:country.mc')
   * t('geo:country.md')
   * t('geo:country.me')
   * t('geo:country.mf')
   * t('geo:country.mg')
   * t('geo:country.mh')
   * t('geo:country.mk')
   * t('geo:country.ml')
   * t('geo:country.mm')
   * t('geo:country.mn')
   * t('geo:country.mo')
   * t('geo:country.mp')
   * t('geo:country.mq')
   * t('geo:country.mr')
   * t('geo:country.ms')
   * t('geo:country.mt')
   * t('geo:country.mu')
   * t('geo:country.mv')
   * t('geo:country.mw')
   * t('geo:country.mx')
   * t('geo:country.my')
   * t('geo:country.mz')
   * t('geo:country.na')
   * t('geo:country.nc')
   * t('geo:country.ne')
   * t('geo:country.nf')
   * t('geo:country.ng')
   * t('geo:country.ni')
   * t('geo:country.nl')
   * t('geo:country.no')
   * t('geo:country.np')
   * t('geo:country.nr')
   * t('geo:country.nu')
   * t('geo:country.nz')
   * t('geo:country.om')
   * t('geo:country.pa')
   * t('geo:country.pe')
   * t('geo:country.pf')
   * t('geo:country.pg')
   * t('geo:country.ph')
   * t('geo:country.pk')
   * t('geo:country.pl')
   * t('geo:country.pm')
   * t('geo:country.pr')
   * t('geo:country.ps')
   * t('geo:country.pt')
   * t('geo:country.pw')
   * t('geo:country.py')
   * t('geo:country.qa')
   * t('geo:country.re')
   * t('geo:country.ro')
   * t('geo:country.rs')
   * t('geo:country.ru')
   * t('geo:country.rw')
   * t('geo:country.sa')
   * t('geo:country.sb')
   * t('geo:country.sc')
   * t('geo:country.sd')
   * t('geo:country.se')
   * t('geo:country.sg')
   * t('geo:country.sh')
   * t('geo:country.si')
   * t('geo:country.sk')
   * t('geo:country.sl')
   * t('geo:country.sm')
   * t('geo:country.sn')
   * t('geo:country.so')
   * t('geo:country.sr')
   * t('geo:country.ss')
   * t('geo:country.st')
   * t('geo:country.sv')
   * t('geo:country.sx')
   * t('geo:country.sy')
   * t('geo:country.sz')
   * t('geo:country.tc')
   * t('geo:country.td')
   * t('geo:country.tg')
   * t('geo:country.th')
   * t('geo:country.tj')
   * t('geo:country.tk')
   * t('geo:country.tl')
   * t('geo:country.tm')
   * t('geo:country.tn')
   * t('geo:country.to')
   * t('geo:country.tr')
   * t('geo:country.tt')
   * t('geo:country.tv')
   * t('geo:country.tw')
   * t('geo:country.tz')
   * t('geo:country.ua')
   * t('geo:country.ug')
   * t('geo:country.us')
   * t('geo:country.uy')
   * t('geo:country.uz')
   * t('geo:country.va')
   * t('geo:country.vc')
   * t('geo:country.ve')
   * t('geo:country.vg')
   * t('geo:country.vi')
   * t('geo:country.vn')
   * t('geo:country.vu')
   * t('geo:country.wf')
   * t('geo:country.ws')
   * t('geo:country.ye')
   * t('geo:country.za')
   * t('geo:country.zm')
   * t('geo:country.zw')
   */
  return i18n.t(`geo:country.${iso2}`);
};
